import { ButtonType, ButtonWidget, TextFieldWidget, ToastType, ToastWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { hoursLeftToExpire, isValidDomain } from '../helpers/CustomDomainHelper';
import CustomDomainHttpClient from '../serverAPI/CustomDomainHttpClient';
import { AddCustomDomainRequest } from '../serverAPI/requests/AddOrUpdateCustomDomainRequest';
import { AddOrUpdateCustomDomainSettingRequest, CustomDomainSettingResponse } from '../serverAPI/types/CustomDomainTypes';
import { customDomainButtonStyle, customDomainContentStyle, customDomainHeaderContainer, customDomainSubHeaderStyle, customDomainWideField, intermediateDomainTextStyle, intermediateDomainwarningStyle, successIconStyle } from '../styles/CustomDomainStyles';

export interface AddCustomDomainViewState {
    isUploading: boolean;
    textValue: string;
  }

export interface AddCustomDomainViewProps {
    customDomainSetting: CustomDomainSettingResponse;
    triggerFetchCustomDomain(): void;
  }

export class AddCustomDomainView extends React.PureComponent<AddCustomDomainViewProps, AddCustomDomainViewState> {
  public constructor(props: AddCustomDomainViewProps) {
    super(props);
    this.state = {
      isUploading: false,
      textValue: ''
    };
  }

  private addCustomDomainSetting = (): void => {
    const customDomainSetting: AddOrUpdateCustomDomainSettingRequest = {
      site_luid: this.props.customDomainSetting.site_luid,
      custom_domain: this.state.textValue,
      status: this.props.customDomainSetting.status,
      tls_certificate: '',
      tls_certificate_private_key: ''
    };

    this.setState({isUploading: true});
    CustomDomainHttpClient.requestPutOrPost(new AddCustomDomainRequest(customDomainSetting)).then((res: CustomDomainSettingResponse)  => {
       this.props.triggerFetchCustomDomain();
     }).catch(err => {
       ToastWidget.show({message: Messages.CustomDomainSetting_addFailed(), testId: 'toast-add-custom-domain-failed', toastType: ToastType.Error});
     }).finally(() => {
      this.setState({isUploading: false});
     });
  };

  private renderIntermediateDomainText() {
    if(!this.props.customDomainSetting?.intermediate_domain) {
      return null;
    }
    let textStyle = intermediateDomainTextStyle;
    let hoursLeft = hoursLeftToExpire(this.props.customDomainSetting?.request_initiation_date);
    if(hoursLeft <= 0) {
      textStyle = intermediateDomainwarningStyle;
    }

    return <div className={textStyle}>
              {Messages.CustomDomainSetting_intermediateDomain({INTERMEDIATE_DOMAIN: this.props.customDomainSetting.intermediate_domain})}{hoursLeft<=0 ? ' '+ Messages.expired() : null}
            </div>;
  }

  private renderIcon() {
    if(this.props.customDomainSetting?.intermediate_domain) {
      return <img src={imgPath('notification_success.svg')} alt='' className={successIconStyle}/>;
    }
    return <img src={imgPath('proceed.svg')} alt='' className={successIconStyle}/>;
  }

  private renderAddCustomDomainSettingView() {
    return <>
          <div className={customDomainContentStyle}>
            <TextFieldWidget testId={'textfield-custom-domain'}
                            className={customDomainWideField}
                            placeholder={'analytics.example.com'}
                            onChange={e => this.setState({textValue : e.target.value})}
                            value={this.state.textValue}
                            required={true}
                            valid={isValidDomain(this.state.textValue)}
                            label={Messages.CustomDomainSetting_addLabelDescription()}
                            disabled={this.props.customDomainSetting?.intermediate_domain ? true : false}
            />
            <div className={customDomainButtonStyle}>
              <ButtonWidget buttonType={ButtonType.Primary} onClick={this.addCustomDomainSetting} testId='button-custom-domain-save' disabled={this.isSaveDisabled()}>
                {Messages.save()}
              </ButtonWidget>
            </div>
          </div>
    </>;

  }

  private isSaveDisabled() {
    if(this.props.customDomainSetting?.intermediate_domain)
      return true;
    return !isValidDomain(this.state.textValue);
  }

  public render() {
    return (
    <>
      <div className={customDomainHeaderContainer}>
        {this.renderIcon()}
        <strong className={customDomainSubHeaderStyle}>{Messages.CustomDomainSetting_addLabel()}</strong>
      </div>
      {this.renderAddCustomDomainSettingView()}
      <div className={customDomainContentStyle}>
         {this.renderIntermediateDomainText()}
      </div>
    </>
    );
  }

}